<template>
  <AssetSelectionList
    ref="list"
    :disabled="disabled"
    :module-name="moduleName"
    :fetch-fn="fetchAssetFn"
    :searchable="false"
    :show-no-data="false"
    :has-actions="!disabled"
  >
    <template
      v-if="!disabled"
      v-slot:action="{ item, stickAction, unstickAction }"
    >
      <FlotoDeleteBtn
        :message="$t('confirm_unconsolidate_item', { item: $tc(moduleName) })"
        @trigger="stickAction"
        @cancel="unstickAction"
        @confirm="handleUnconsolidate(item)"
      >
        <MTooltip>
          <template v-slot:trigger>
            <MIcon name="unlink" size="lg" />
          </template>
          {{ $t('unconsolidate') }}
        </MTooltip>
      </FlotoDeleteBtn>
    </template>
  </AssetSelectionList>
</template>

<script>
import AssetSelectionList from '@components/item-selection-list/asset-list'
import { transformSearchCriteriaForServer } from '@data/search'
import { searchAssetsApi, updateApi } from '@modules/asset/asset-api'
export default {
  name: 'ConsolidateSoftwareTab',
  components: { AssetSelectionList },
  props: {
    resourceId: { type: Number, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      moduleName: this.$constants.ASSET_SOFTWARE,
    }
  },
  methods: {
    fetchAssetFn(moduleName, criterias, limit, offset) {
      const q = transformSearchCriteriaForServer(moduleName, {
        operator: { value: 'equal' },
        paramName: 'parentAssetId',
        value: this.resourceId,
        valueType: 'long',
        paramType: 'db',
      })
      criterias.quals.push(q)
      return searchAssetsApi(moduleName, criterias, limit, offset)
    },
    handleUnconsolidate(item) {
      updateApi(this.moduleName, {
        id: item.id,
        parentAssetId: 0,
        type: item.type,
      }).then(() => {
        this.$refs.list.refresh()
      })
    },
  },
}
</script>
